const nsoZA= {
    login: {
      title: 'Tsena',
      sign_in_btn: 'Tsena'
    },
    bar: {
        logout: 'Etšwa',
        languages: 'Maleme',
        settings: 'Bula dipeakanyo'
    },
    language: {
      name: 'Sepedi (Afrika Borwa)',
    },
    attributePage: {
        title: 'Phetogo ya Dika',
        viewChanges: 'Bona Diphetogo',
        dateTime: 'Letšatšikgwedi',
        notificationType: 'Mohuta wa Tsebišo',
        notificationValue: 'Nomoro ya go Tsebiša',
        oldValue: 'Nomoro ya Kgale',
        newValue: 'Nomoro ye Mpsha',
        accept: 'Amogela',
        reject: 'Gana',
    },
    Home: 'Gae',
    load: 'E thomološa go laisa...',
    Requested: "Kgopetše",
    Viewed: "Bonwe",
    Executing: "E a thoma",
    Completed: "Feditše",
    Expired: "Feletšwe ke nako",
    Cancelled: "Phumotše",
    Error: "Phošo",
    Rejected: "Ganne",
    error: 'Se sengwe ga se sepela gabotse; hle leka gape nakong yeo e tlago.',
    displayname: 'Leina le Taetšo',
    givenname: 'Leina',
    surname: 'Sefane',
    email: 'Emeili',
    mail: 'Emeili',
    name: 'Leina',
    firstname: 'Leina',
    lastname: 'Sefane',
    footer_copyright: 'Ditokelo ka moka di beetšwe thoko.'
  };
  
  export default nsoZA;
  